import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import Loader from './Loader';
import parseQueryParams from '../lib/parseQueryParams';

class Auth extends Component {
  componentDidMount() {
    const {
      authToken,
      authTokenType,
      getSession,
      location,
      history
    } = this.props;
    if (authToken && authTokenType) {
      getSession(authTokenType, authToken);
      const { token, guid, ...remainingParams } = parseQueryParams(location.search);
      const search = new URLSearchParams(remainingParams).toString();
      history.replace(search ? `${location.pathname}?${search}` : location.pathname);
    }
  }
  render() {
    const { session, children, authToken } = this.props;

    return (
      <Loader isLoading={!!(authToken && !session.token)}>
        {session.token ? (
          children || <div />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              search: this.props.location.search,
              state: { referrer: this.props.location }
            }}
          />
        )}
      </Loader>
    );
  }
}
Auth.propTypes = {
  getSession: PropTypes.func.isRequired,
  authToken: PropTypes.string,
  authTokenType: PropTypes.string,
  children: PropTypes.node,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired
  }).isRequired,
  session: PropTypes.shape({
    token: PropTypes.string
  })
};
Auth.defaultProps = {
  authToken: '',
  authTokenType: undefined,
  children: [],
  session: {}
};

export default Auth;
